<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" color="dark">mdi-square-edit-outline</v-icon>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Edit HomePage Package</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="mt-2">
            <v-form @submit="updateForm()" v-model="valid" ref="form">
              <v-row>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text mb-2">Select Package</h4>
                  <v-autocomplete item-text="titleEn" v-model="data.package._id" item-value="_id" :items="packagesList" :rules="[requiredValidator('package')]" placeholder="Select package" dense solo>
                    <template slot="no-data">
                      <v-flex xs12 md12 class="mt-2 mb-2">
                        <h5 class="font-weight-medium ml-4">
                          Search for package...
                        </h5>
                      </v-flex>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text mb-2">Display Type</h4>
                  <v-select :items="['PRIMARY', 'SECONDARY']" v-model="data.planShowType" label="Select" dense solo></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text mb-2">Price</h4>
                  <v-text-field solo name="input-7-4" type="number" label="Price" v-model="data.price"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Image</h4>
                  <input type="file" accept="image/*" @change="onFileSelected($event)" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                    {{ snackText }}
                  </v-snackbar>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Image for Mobile</h4>
                  <input type="file" accept="image/*" @change="onFileSelectedMob($event)" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                    {{ snackText }}
                  </v-snackbar>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Show Order</h4>
                  <v-text-field solo name="input-7-4" label="Show Order" v-model="data.showOrder"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="dark--text text-body-2">Currently Active</h4>
                  <v-radio-group row v-model="data.isActive">
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row>
                <v-checkbox label="Modify Card Colors" v-model="data.modifyColor"></v-checkbox>
              </v-row>

              <v-row v-if="data.modifyColor">
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Background Color</h4>
                  <v-text-field v-model="data.color1" @click="showMenu1()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu1" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="data.color1" flat @input="setColor1"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Heading Text Color</h4>
                  <v-text-field v-model="data.color2" @click="showMenu2()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu2" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="data.color2" flat @input="setColor2"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Boarder Color</h4>
                  <v-text-field v-model="data.color3" @click="showMenu3()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu3" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="data.color3" flat @input="setColor3"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Button Fill Color</h4>
                  <v-text-field v-model="data.color4" @click="showMenu4()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu4" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="data.color4" flat @input="setColor4"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Button Boarder Color</h4>
                  <v-text-field v-model="data.color5" @click="showMenu5()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu5" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="data.color5" flat @input="setColor5"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="mt-n8 justify-end">
          <v-btn color="primary" class="light--text mb-2 mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="updateForm" :loading="btnloading" :disabled="!valid">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";

export default {
  props: {
    data: {
      required: true,
    },
  },
  data() {
    return {
      btnloading: false,
      valid: true,
      errors: [],
      text: "",
      question: "",
      answer: "",
      showOrder: 0,
      active: true,
      show_dialog_box: false,
      requiredValidator: requiredValidator,
      packagesList: [],
      snackbar: false,
      snackColor: "",
      snackText: "",
      imageUrl: process.env.VUE_APP_BASE_URL,
      packageImage: null,
      packageImageMob: null,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
    };
  },
  apollo: {
    getAllPackages() {
      return {
        query: require("@/menu-packages/api/getAllPackages.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;
          this.packagesList = data.getAllPackages.packages.filter(x => x.active == true);
        },
      };
    },
  },
  methods: {
    showMenu1() {
      this.menu1 = true;
    },
    showMenu2() {
      this.menu2 = true;
    },
    showMenu3() {
      this.menu3 = true;
    },
    showMenu4() {
      this.menu4 = true;
    },
    showMenu5() {
      this.menu5 = true;
    },
    setColor1(color) {
      this.data.color1 = color;
    },
    setColor2(color) {
      this.data.color2 = color;
    },
    setColor3(color) {
      this.data.color3 = color;
    },
    setColor4(color) {
      this.data.color4 = color;
    },
    setColor5(color) {
      this.data.color5 = color;
    },
    close() {
      this.show_dialog_box = false;
    },
    updateForm() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../api/updateWebHomePackage.graphql"),
          variables: {
            id: this.data._id,
            planShowType: this.data.planShowType,
            price: parseFloat(this.data.price ? this.data.price : 0),
            package: this.data.package._id,
            image: this.packageImage,
            imageMob: this.packageImageMob,
            showOrder: parseInt(this.data.showOrder),
            isActive: this.data.isActive,
            color1: this.data.color1,
            color2: this.data.color2,
            color3: this.data.color3,
            color4: this.data.color4,
            color5: this.data.color5,
            modifyColor: this.data.modifyColor,
          },
          update: () => {
            this.$root.$emit("updateHomePackage");
            // this.$refs.form.reset();
            this.btnloading = false;
            this.show_dialog_box = false;
          },
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getImage() {
      if (this.data.packageImage) return this.imageUrl + this.data.packageImage;
      else return require("../../assets/no-image.png");
    },
    onFileSelected(event) {
      const selectedFile = event.target.files[0];
      this.packageImage = selectedFile;
    },
    onFileSelectedMob(event) {
      const selectedFile = event.target.files[0];
      this.packageImageMob = selectedFile;
    },
  },
};
</script>
<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
